import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'gold' | 'outline' | 'outline-light'

type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonClassOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
}

const variants: Record<ButtonVariant, string> = {
    primary: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 hover:shadow-md',
    gold: 'bg-gold text-gold-foreground shadow-sm hover:bg-gold/90 hover:shadow-md',
    outline: 'border border-foreground/15 bg-card/70 text-foreground hover:border-foreground/30 hover:bg-card',
    'outline-light': 'border border-primary-foreground/25 text-primary-foreground hover:border-primary-foreground/45 hover:bg-primary-foreground/10'
}

const sizes: Record<ButtonSize, string> = {
    sm: 'h-10 px-4 text-sm',
    md: 'h-12 px-6 text-sm',
    lg: 'h-14 px-7 text-base'
}

export const buttonClassName = ({ variant = 'primary', size = 'md', className }: ButtonClassOptions = {}): string => {
    return cn(
        'inline-flex shrink-0 cursor-pointer select-none items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap transition-all duration-200',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
        'disabled:pointer-events-none disabled:opacity-60',
        sizes[size],
        variants[variant],
        className
    )
}
